<template>
  <div class="row">
    <card class="card">
      <div class="row">
        <base-checkbox style="z-index: 100" v-if="hasCheck" v-model="isChecked"></base-checkbox>
      </div>
      <div v-if="imageUrls.length > 0">
        <div class="row image-box" v-if="imageUrls.length > 1">
          <div class="col-sm-6">
            <img slot="image" v-if="imageUrls.length > 0" @click="showImage(0)" class="card-img-top cover-img" v-bind:src="imageUrls[0]" alt="Card image cap" />
          </div>
          <div class="col-sm-6">
            <img v-if="imageUrls.length > 1" slot="image" @click="showImage(1)" class="card-img-top" v-bind:src="imageUrls[1]" alt="Card image cap" />
            <img v-if="imageUrls.length > 2" slot="image" @click="showImage(2)" class="card-img-top" v-bind:src="imageUrls[2]" alt="Card image cap" />
          </div>
        </div>
        <div class="row image-box" v-if="imageUrls.length === 1">
          <div class="col-sm-12">
            <img slot="image" @click="showImage(0)" class="card-img-top cover-img" v-bind:src="imageUrls[0]" alt="Card image cap" />
          </div>
        </div>
      </div>
      <div class="row image-box" v-else></div>
      <div>
        <p class="card-text">[{{ contentId }}] {{ title | truncate(120) }}</p>
        <p class="card-text" v-if="scheduleId">
          <a @click="goSchedulePage()">스케줄 ID : {{ scheduleId }}</a>
        </p>
        <p class="card-text" v-if="viewCount">
          뷰수:{{ viewCount }}/댓글수:{{ commentCount }}
          <br />
          좋아요수:{{ likeCount }}/북마크:{{ pinCount }}
        </p>
        <p class="card-text">{{ regDate }}</p>
        <p class="card-text" v-if="startTime">{{ startTime }} ~ {{ endTime }}</p>
        <base-button v-if="btnDetail" @click="contentDetail" type="default">상세</base-button>
        <base-button v-if="btnNotification" @click="sendNotification" type="default">알림전송</base-button>
        <base-button v-if="btnDelete && state != -1" @click="deleteContent" type="danger">숨김</base-button>
      </div>
    </card>
    <vue-gallery-slideshow :images="imageUrls" :index="imageIndex" @close="closeImage"></vue-gallery-slideshow>
  </div>
</template>

<script>
import { Card, BaseButton } from "@/components/index";
import VueGallerySlideshow from "vue-gallery-slideshow";

export default {
  name: "CardLayout",
  created() {},
  components: {
    Card,
    BaseButton,
    VueGallerySlideshow,
  },
  props: {
    contentId: Number,
    title: String,
    fileIds: Array,
    index: {
      type: Number,
      required: false,
    },
    scheduleId: {
      type: Number,
      required: false,
    },
    scheduleUrl: {
      type: String,
      required: false,
    },
    viewCount: {
      type: Number,
      required: false,
    },
    commentCount: {
      type: Number,
      required: false,
    },
    likeCount: {
      type: Number,
      required: false,
    },
    pinCount: {
      type: Number,
      required: false,
    },
    startTime: {
      type: String,
      required: false,
    },
    endTime: {
      type: String,
      required: false,
    },
    regDate: String,
    state: {
      type: Number,
      required: false,
    },
    btnDetail: {
      type: Boolean,
      required: false,
    },
    btnNotification: {
      type: Boolean,
      required: false,
    },
    btnDelete: {
      type: Boolean,
      required: false,
    },
    isChecked: Boolean,
    hasCheck: {
      type: Boolean,
      required: false,
    },
  },
  watch: {
    fileIds: {
      handler() {
        this.imageUrls = [];
        if (this.fileIds) {
          for (let i = 0; i < this.fileIds.length; i++) {
            this.imageUrls.push(window.Endpoints.imageServerUrl + this.fileIds[i]);
          }
        }
      },
      immediate: true,
    },
    isChecked: {
      handler() {
        this.$emit("setCheckBox", {
          index: this.index,
          isChecked: this.isChecked,
        });
      },
    },
  },
  data() {
    return {
      imageUrls: [],
      imageIndex: null,
    };
  },
  methods: {
    deleteContent() {
      this.$emit("deleteContent", {
        contentId: this.contentId,
        title: this.title,
      });
    },
    sendNotification() {
      this.$emit("sendNotification", {
        contentId: this.contentId,
      });
    },
    goSchedulePage() {
      this.$router.push(this.scheduleUrl);
    },
    showImage(index) {
      this.imageIndex = index;
    },
    contentDetail() {
      this.$emit("contentDetail", {
        contentId: this.contentId,
      });
    },
    closeImage() {
      this.imageIndex = null;
    },
    setCheckBox() {
      console.log(1);
      // this.isChecked = !this.isChecked;
      this.$emit("setCheckBox", {
        index: this.key,
        isChecked: true,
      });
    },
  },
};
</script>
<style scoped>
.cover-img {
  height: 150px !important;
  width: 100%;
}
.card {
  border: double;
}
.image-box {
  height: 150px;
}
img {
  object-fit: cover;
  height: 75px;
  width: 100%;
  cursor: pointer;
}
</style>
